import moment from "moment-timezone";
import timeZones from "./timeZones";
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
// 获取url中的参数
function getParameter(name, url = window.location.search) {
    const regexp = new RegExp(`[?&]${name}=([^&#]*)`, 'ig');
    const result = regexp.exec(url);
    return result === null ? '' : decodeURIComponent(result[1]);
};

/**
 * 时间类型数据补0
 * @param {*} n 
 */
function addZero(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
}

/**
 * 获取默认时区
 */
function getDefaultTimezone() {
    const zone = timeZones.find(el => el.name === moment.tz.guess());
    Object.assign(zone, { zonename: 'GMT' });
    return zone;
}

/**
 * 获取年月日周几
 * @param {*} date 开始时间
 */
function getWeek(date) {
    const weekList = {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
    };
    const week = weekList[moment(date).day()];
    return week;
}
/**
 * [getCookie 获取cookie]
 */
function getCookie(key) {
    const arr1 = document.cookie.split("; ");//由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
    for (let i = 0; i < arr1.length; i++) {
        let arr2 = arr1[i].split("=");//通过=截断，把name=Jack截断成[name,Jack]数组；
        if (arr2[0] == key) {
            return decodeURI(arr2[1]);
        }
    }
}
/* 通过周取日期范围 */
//通过周取日期范围   year 年   weeks 周
function weekGetDate(year, weeks) {

    Date.prototype.Format = function (fmt) { //需要JS格式化时间，后期做的时候方便使用   
        var o = {
            "M+": this.getMonth() + 1,                 //月份   
            "d+": this.getDate(),                    //日   
            "h+": this.getHours(),                   //小时   
            "m+": this.getMinutes(),                 //分   
            "s+": this.getSeconds(),                 //秒   
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
            "S": this.getMilliseconds()             //毫秒   
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    };
    var date = new Date(year, "0", "1");
    // 获取当前星期几,0:星期一 
    var time = date.getTime();
    //当这一年的1月1日为周日时则本年有54周,否则没有54周,没有则去除第54周的提示       
    var _week = date.getDay();

    if (_week != 0) {//一年53周情况 
        if (weeks == 54) {
            return '今年没有54周';
        }
        var cnt = 0;// 获取距离周末的天数    
        if (_week == 0) {
            cnt = 7;
        } else if (_week == 1) {
            cnt = 6;
        } else if (_week == 2) {
            cnt = 5;
        } else if (_week == 3) {
            cnt = 4;
        } else if (_week == 4) {
            cnt = 3;
        } else if (_week == 5) {
            cnt = 2;
        } else if (_week == 6) {
            cnt = 1;
        }
        // cnt += 1;//加1表示以星期一为一周的第一天    // 将这个长整形时间加上第N周的时间偏移    
        time += cnt * 24 * 3600000; //第2周开始时间 
        var nextYear = new Date(parseInt(year, 10) + 1, "0", "1");
        var nextWeek = nextYear.getDay();
        var lastcnt = 0;//获取最后一周开始时间到周末的天数    
        if (nextWeek == 0) {
            lastcnt = 6;
        } else if (nextWeek == 1) {
            lastcnt = 0;
        } else if (nextWeek == 2) {
            lastcnt = 1;
        } else if (nextWeek == 3) {
            lastcnt = 2;
        } else if (nextWeek == 4) {
            lastcnt = 3;
        } else if (nextWeek == 5) {
            lastcnt = 4;
        } else if (nextWeek == 6) {
            lastcnt = 5;
        }
        if (weeks == 1) {//第1周特殊处理    // 为日期对象 date 重新设置成时间 time
            var start = date.Format("yyyy/MM/dd");
            date.setTime(time - 24 * 7 * 3600000);
            var _end = date.Format("yyyy/MM/dd");

            return _end + "-----" + start;
        } else if (weeks == 53) {//第53周特殊处理  
            //第53周开始时间      
            var start = time + (weeks - 2) * 7 * 24 * 3600000;
            //第53周结束时间
            var end = time + (weeks - 2) * 7 * 24 * 3600000 + lastcnt * 24 * 3600000 - 24 * 3600000;
            date.setTime(start);
            var _start = date.Format("yyyy/MM/dd");
            date.setTime(end);
            var _end = date.Format("yyyy/MM/dd");
            return _start + "-" + _end;
        } else {
            var start = time + (weeks - 2) * 7 * 24 * 3600000; //第n周开始时间    
            var end = time + (weeks - 1) * 7 * 24 * 3600000 - 24 * 3600000; //第n周结束时间
            date.setTime(start);
            var _start = date.Format("yyyy/MM/dd");
            date.setTime(end);
            var _end = date.Format("yyyy/MM/dd");
            return _start + "-" + _end;
        }
    } else {//一年54周情况    
        var cnt = 0;// 获取距离周末的天数    
        if (_week == 0 && weeks == 1) {//第一周    
            cnt = 0;
        } else if (_week == 0) {
            cnt = 7;
        } else if (_week == 1) {
            cnt = 6;
        } else if (_week == 2) {
            cnt = 5;
        } else if (_week == 3) {
            cnt = 4;
        } else if (_week == 4) {
            cnt = 3;
        } else if (_week == 5) {
            cnt = 2;
        } else if (_week == 6) {
            cnt = 1;
        }
        // cnt += 1;//加1表示以星期一为一周的第一天    
        // 将这个长整形时间加上第N周的时间偏移    
        time += 24 * 3600000; //第2周开始时间    
        var nextYear = new Date(parseInt(year, 10) + 1, "0", "1");
        var nextWeek = nextYear.getDay();
        var lastcnt = 0;//获取最后一周开始时间到周末的天数    
        if (nextWeek == 0) {
            lastcnt = 6;
        } else if (nextWeek == 1) {
            lastcnt = 0;
        } else if (nextWeek == 2) {
            lastcnt = 1;
        } else if (nextWeek == 3) {
            lastcnt = 2;
        } else if (nextWeek == 4) {
            lastcnt = 3;
        } else if (nextWeek == 5) {
            lastcnt = 4;
        } else if (nextWeek == 6) {
            lastcnt = 5;
        }
        if (weeks == 1) {//第1周特殊处理
            var start = date.Format("yyyy/MM/dd");
            date.setTime(time - 24 * 3600000);
            alert(start + '--' + date);
            return _start + "-" + date;
        } else if (weeks == 54) {//第54周特殊处理   
            //第54周开始时间    
            var start = time + (weeks - 2) * 7 * 24 * 3600000;
            //第53周结束时间 
            var end = time + (weeks - 2) * 7 * 24 * 3600000 + lastcnt * 24 * 3600000 - 24 * 3600000;
            date.setTime(start);
            var _start = date.Format("yyyy/MM/dd");
            date.setTime(end);
            var _end = date.Format("yyyy/MM/dd");
            return _start + "-" + _end;
        } else {
            var start = time + (weeks - 2) * 7 * 24 * 3600000; //第n周开始时间    
            var end = time + (weeks - 1) * 7 * 24 * 3600000 - 24 * 3600000; //第n周结束时间
            date.setTime(start);
            var _start = date.Format("yyyy/MM/dd");
            date.setTime(end);
            var _end = date.Format("yyyy/MM/dd");
            return _start + "-" + _end;
        }
    }
}


// 第n年的第n周，获取开始和结束时间 （星期一为一周的开始），例如2020-1
function weekDate(weekstr, sundayStart = "0") {
    let year = weekstr.split("-")[0]
    let weekNo = weekstr.split("-")[1]
    // 此年1号是星期几
    let oneday = new Date(year + '/01/01').getDay() + 1 //0-6
    // 方便计算，当为星期天时为8
    if (oneday == 0) {
        oneday = 8
    }
    if (sundayStart === "1") { //周一为起始日
        oneday = new Date(year + '/01/01').getDay() //0-6
        // 方便计算，当为星期天时为7
        if (oneday == 0) {
            oneday = 7
        }
    }

    let one_fistday;
    let one_lastday;
    // 如果1号刚好是星期一
    if (oneday == 1) {
        one_fistday = year + '/01/01'
        one_lastday = year + '/01/07'
    } else {
        let jj = 8 - oneday
        one_fistday = (year - 1) + '/12/' + (31 - oneday + 2 > 9 ? 31 - oneday + 2 : '0' + (31 - oneday + 2))
        one_lastday = year + '/01/' + (jj > 9 ? jj : '0' + jj)
    }

    let fistday;
    let lastday;
    // 如果刚好是第一周
    if (weekNo == 1) {
        fistday = one_fistday
        lastday = one_lastday
    } else {
        fistday = addDate(one_lastday, (weekNo - 2) * 7 + 1)
        lastday = addDate(one_lastday, (weekNo - 1) * 7)
    }
    return [fistday, lastday]
}

//日期加减法  date参数为计算开始的日期，days为需要加的天数   
//格式:addDate('2017-1-11',20) 
function addDate(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    var m = d.getMonth() + 1;
    return d.getFullYear() + '/' + (m > 9 ? m : '0' + m) + '/' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
}
const useWxCode = () => {
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const urlCode = searchParams.get('code');
        const localCode = sessionStorage.getItem('code');
        if (!urlCode && !localCode) {
            const appid = 'wx754e1b2a81936e91'; // 微信授权的公众号的appid
            const redirectUrl = encodeURIComponent(window.location.href);
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
        } else if (urlCode) {
            sessionStorage.setItem('code', urlCode);
            history.goBack();
        }
        return () => sessionStorage.removeItem('code');
    }, []);

    return sessionStorage.getItem('code');
}
export {
    getParameter,
    getDefaultTimezone,
    addZero,
    getWeek,
    getCookie,
    weekGetDate,
    weekDate,
    useWxCode
}